import { useQuery } from '@apollo/client';
import { FC } from 'react';
import AdminContent from '../../components/AdminContent';
import ElementsList from './components/ElementsList';
import { Element } from './models';
import { GET_ELEMENTS_DATA } from './queries';

export const componentsPageInfo = {
  title: 'Componentes',
  description: 'Personalize configurações gerais dos componentes',
  path: 'components',
};

const ComponentsPage: FC = () => {
  const { data } = useQuery<{ elements: Element[] }>(GET_ELEMENTS_DATA);
  const elements = data?.elements;
  return (
    <>
      <AdminContent
        title={componentsPageInfo.title}
        description={componentsPageInfo.description}
      >
        <ElementsList elements={elements} />
      </AdminContent>
    </>
  );
};
export default ComponentsPage;
